export const getFullScreenImageSources = () => {
  return [
    // Mobile devices
    {
      width: 390,
      height: 844,
      media: 390,
    },
    {
      width: 430,
      height: 932,
      media: 430,
    },
    {
      width: 768,
      height: 1024,
      media: 768,
    },
    // Tablet devices
    {
      width: 1024,
      height: 768,
      media: 1024,
    },
    // Desktop devices
    {
      width: 1280,
      height: 800,
      media: 1280,
    },
    {
      width: 1366,
      height: 768,
      media: 1366,
    },
    {
      width: 1920,
      height: 1080,
      media: 1920,
    },
    {
      width: 2560,
      height: 1440,
      media: 2560,
    },
  ];
};

const mapBreakpointsToSources = (height, bpEntries) => {
  return bpEntries.map(screenSize => ({
    width: screenSize.width,
    height,
    media: screenSize.media,
  }));
};

export const getFullScreenParallaxImageSources = (
  parallaxMultiplier,
  minCutoff,
  maxCutoff
) => {
  return getFullScreenImageSources()
    .filter(
      screenSize =>
        (typeof minCutoff !== 'undefined'
          ? screenSize.media >= minCutoff
          : true) &&
        (typeof maxCutoff !== 'undefined' ? screenSize.media < maxCutoff : true)
    )
    .map(screenSize => {
      return {
        width: screenSize.width,
        height: screenSize.height * parallaxMultiplier,
        media: screenSize.media,
      };
    });
};

export const getFixedProportionParallaxImageSources = (
  aspectRatio = 0.7,
  parallaxMultiplier,
  minCutoff,
  maxCutoff
) => {
  return getFullScreenImageSources()
    .filter(
      screenSize =>
        (typeof minCutoff !== 'undefined'
          ? screenSize.media >= minCutoff
          : true) &&
        (typeof maxCutoff !== 'undefined' ? screenSize.media < maxCutoff : true)
    )
    .map(screenSize => {
      return {
        width: screenSize.width,
        height: screenSize.width * aspectRatio * parallaxMultiplier,
        media: screenSize.media,
      };
    });
};

export const getFullWidthImageSourcesMobile = (height, cutoff = 1024) => {
  const bpEntries = getFullScreenImageSources().filter(
    screenSize => screenSize.media !== 0 && screenSize.media < cutoff
  );

  return mapBreakpointsToSources(height, bpEntries);
};

export const getFullWidthImageSourcesDesktop = (
  height,
  minCutoff = 1024,
  maxCutoff = undefined
) => {
  const bpEntries = getFullScreenImageSources().filter(
    screenSize =>
      screenSize.media !== 0 &&
      screenSize.media >= minCutoff &&
      (typeof maxCutoff !== 'undefined' ? screenSize.media < maxCutoff : true)
  );

  return mapBreakpointsToSources(height, bpEntries);
};
